import * as React from 'react';
import { SVGProps } from 'react';

const IconMGRPSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.222 3.017 10 5h5v2H1V5h5.222L6 3.017l1.778-1.724L7.333 0 8.73 1.293l-.508 1.724ZM15 9H1v2h5l1.778 1.983-.508 1.724L8.667 16l-.445-1.293L10 12.983 9.778 11H15V9Z" />
  </svg>
);
export default IconMGRPSizeS;
